<template>
	<view class="rich-text-page">
		<view class="rich-content" v-html="content"></view>
	</view>
</template>

<script>
	export default {
		data() {
			return {
				type: '',
				content: ''
			}
		},
		onLoad(options) {
			this.id = options.id 
			this.getBannerDetai()
		},
		methods: {
			async getBannerDetai() {
				const res = await this.$u.api.getBannerDetail({ id: this.id })
				if (res.code === 200) {
					this.content = res.data.content || ''
				}
			}
		}
	}
</script>

<style lang="scss" scoped>
	.rich-text-page {
		min-height: 100vh;
		background: #ffffff;
		padding: 30rpx;
		box-sizing: border-box;
	}

	.rich-content {
		width: 100%;
		font-size: 28rpx;
		color: #333333;
		line-height: 1.6;

		::v-deep {
			image {
				max-width: 100% !important;
				height: auto !important;
			}
			p {
				margin-bottom: 20rpx;
			}
		}
	}
</style>
